<template>
  <div>
          <div class="app-nav">
      <div class="row expanded">
        <div class="columns">
          <nav>
          </nav>
        </div>
      </div>
    </div>
    <div
      :class="`${this.loginFailed ? 'container body-content' : 'not-show'}`"
      
    >
      <main>

        <div class="large-24 columns divText">
          <p>
            THIS USER DOESN'T HAVE ACCESS. <br />PLEASE CONTACT THE SANITATION
            RECYCLE AREA.
          </p>
        </div>
      </main>
    </div>
       <div class="columns is-centered">
        <p class="column is-12">
          Welcome to Sanitation Recycle System. 
          <br>Using the system you will be able to:
          <ul>
            <li>Add request for bin;</li>
            <li>Delivery the bin;</li>
          </ul>
        </p>
      </div>
    <div style="padding: 20px;">
      <a class="button" @click.prevent="doLogin">LogIn</a>
    </div>
  </div>
</template>
<script>

export default {
  name: "Login",
  components: {
  },
  data() {
    return {
      loginIn: false,
      loginFailed: false,
    };
  },
  beforeMount() {
    console.log("Clearing local storage");
    window.localStorage.clear();
  },
  methods: {
    async doLogin() {
      const accessToken = await this.$store.dispatch("login/getToken");
      console.log("Did we get a token?", accessToken);
      if (accessToken) {
        this.loginIn = true;
        this.loginFailed = false;
        document.location = this.$router.resolve({ name: "deliveryform" }).href;
      } else {
        //TODO We need to notify login failed the user here.
        this.loginFailed = true;
        console.warn(
          "It seems that you don't have access. Please verify your internet access and that you entered the correct City Account.\nIf the problem persists contact the system administrators; you likely need to be added to the Active Directory Group for this application."
        );
      }
      this.loginIn = false;
    },
  },
};
</script>
<style scoped>
.not-show {
  display: none;
}
button {
  margin-top: 30px;
  height: 100%;
}
ul {
  list-style-type: disc;
  list-style-position: inside;
  padding: 15px 0 0 5px;
}
</style>
